function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.06 76.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.35.36C-.78,1.22-.27,16.69,2.09,22.67c1.67,4.23,2.06,8.15,2.44,24.29.46,19.95,1.68,27.16,4.95,29.19,2.31,1.44,3.59-.78,3.61-6.26,0-2.37.44-7.32.97-11,.52-3.68,1.47-12.54,2.1-19.69.63-7.15,1.78-15.22,2.55-17.93,1.54-5.41,1.85-15.32.54-17.37C17.81,1.64,4.63-.97,1.35.36",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,4.14c3.57,1.01,4.04,1.51,4.33,4.59.18,1.9-.49,7.2-1.49,11.76l-1.82,8.3-4.01-.3c-3.85-.28-4.1-.52-6.23-5.8C2.24,17.4,1.14,3.99,2.71,2.41c.67-.67,4.61-.05,10.88,1.73",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.63,32.45c-.37.96-1.14,7.38-1.7,14.25-2.48,30.36-2.42,30.06-4.76,21.3-1.13-4.22-2.23-33.72-1.34-36.05.27-.71,2.2-1.25,4.48-1.25,3.4,0,3.9.26,3.32,1.75",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.4a17599baf31f8eb1187cdef8be73715.svg";
export { ForwardRef as ReactComponent };